import { createStore } from 'vuex'
import auth from './modules/auth'
import employees from './modules/employees'
import attendance from './modules/attendance'
import leaves from './modules/leaves'
import payroll from './modules/payroll'
import countries from './modules/countries'
import cities from './modules/cities'
import companies from './modules/companies'
import departments from './modules/departments'
import documentTypes from './modules/documentTypes'
import documents from './modules/documents'
import employmentTypes from './modules/employmentTypes'
import roles from './modules/roles'

export default createStore({
  modules: {
    auth,
    employees,
    attendance,
    leaves,
    payroll,
    countries,
    cities,
    companies,
    departments,
    documentTypes,
    documents,
    employmentTypes,
    roles
  }
}) 